import React from 'react';

import useTranslateLpc from '@components/common/hooks/useTranslateLpc';

import css from './MoreActions.module.scss';

type MoreActionsProps = {
    isPopUpOpen: boolean;
    customClass?: string;
    onApplyAction: (str: 'delete' | 'edit') => void;
};

const MoreActions = ({ isPopUpOpen, customClass, onApplyAction }: MoreActionsProps) => {
    const { t } = useTranslateLpc('lpc-pot-payment');

    return (
        <>
            <div className={`${css.more_actions} ${isPopUpOpen && css.more_actions__open} ${customClass || ''}`}>
                <span onClick={() => onApplyAction('edit')} className={css.more_actions__cta}>
                    {t('success.greeting.edit')}
                </span>
                <span onClick={() => onApplyAction('delete')} className={css.more_actions__cta}>
                    {t('success.greeting.delete')}
                </span>
            </div>
        </>
    );
};
export default MoreActions;
